/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";

import {AigiaComponent} from "./aigia.component";
import {GuestsComponent} from "./guests/guests.component";
import {Guests2Component} from "./guests2/guests2.component";
import {ShotdataComponent} from "./shotdata/shotdata.component";
import {TopComponent} from "./top/top.component";
import {ShotdataDialogComponent} from "./shotdata/shotdata-dialog/shotdata-dialog.component";
import {ProfileComponent} from "./profile/profile.component";
import {Profile2Component} from "./profile2/profile2.component";
import {PaymentComponent} from "./payment/payment.component";
import {InquiriesComponent} from "./inquiry/inquiries.component";

import {HomeComponent} from "./home/home.component";
import {NewsComponent} from "./news/news.component";
import {NewsDescriptionComponent} from "./news/description/news.description.component";

import {StaticvideoComponent} from "./staticvideo/staticvideo.component";
import {ContactComponent} from "./contact/contact.component";

const routes: Routes = [
	{
		path: "", component: AigiaComponent, children: [
			{path: "guests", component: GuestsComponent, data: {animation: "guests"}},
			{path: "guests2", component: Guests2Component, data: {animation: "guests2"}},
			{path: "shotdata", component: ShotdataComponent, data: {animation: "shotdata"}},
			{path: "training", component: ShotdataDialogComponent, data: {animation: "training"}},
			{path: "profile", component: ProfileComponent, data: {animation: "profile"}},
			{path: "profile2", component: Profile2Component, data: {animation: "profile2"}},
			{path: "payment", component: PaymentComponent, data: {animation: "payment"}},
			{path: "inquiries", component: InquiriesComponent, data: {animation: 'inquiries'}},
			{path: "contacts", component: ContactComponent, data: {animation: 'contacts'}},
			{path: "staticvideo", component: StaticvideoComponent, data: {animation: 'staticvideo'}},
			{path: "home", component: HomeComponent, data: {animation: 'home'}},
			{path: "news", component: NewsComponent, data: {animation: 'news'}},
			{path: "news-description/:id", component: NewsDescriptionComponent, data: {animation: 'news'}},
			{path: "", component: TopComponent, data: {animation: "top"}},
		]
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})

export class AigiaRoutingModule {
}
